import React from 'react';
import styled from 'styled-components';

const MenuWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  margin: 0 auto;
  box-sizing: border-box;
  border-radius: 8px 8px 8px 8px;
  pointer-events: all !important;
  background-color: #ffffff;
`;

const ItemsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 20px;
  border-radius: 8px 8px 8px 8px;
`;

const PopupMenu = (props) => {
  const { style, children } = props;

  return (
    <div style={{ position: 'fixed', ...style, zIndex: 110, borderRadius: '0px 4px 4px 0px' }}>
      <MenuWrapper style={{ position: 'relative' }}>
        <ItemsWrapper>{children}</ItemsWrapper>
      </MenuWrapper>
    </div>
  );
};

export { PopupMenu };
